<template>
	<div class="wrapper offline">
		<div class="content">
			<h1>Offline</h1>
			<p>Preverite internetno povezavo in poskusite znova.</p>
			<p>Please check your internet connection and try again.</p>
			<p>Controlla la tua connessione Internet e riprova.</p>
		</div>
	</div>
</template>

<script>
export default {
	name: 'OfflinePage'
};
</script>

<style scoped>
/* Add styles for your offline page */
</style>